/**
 * check Ernte: keine Ernte
 */
window.checkErnteKeineErnte = function() {
  const editKeineErnte = $('#edit-keine-ernte');
  const erntegaenge = editKeineErnte.closest('.modal-body').find('input[type="date"]');

  editKeineErnte.on('change', function() {
    if ($(this).is(':checked')) {
      erntegaenge.val('').attr('disabled', 'disabled');
    } else {
      erntegaenge.removeAttr('disabled');
    }
  });

  if (editKeineErnte.is(':checked')) {
    erntegaenge.val('').attr('disabled', 'disabled');
  }
};

/**
 * check Blühbeginn: kein Blühbeginn
 */
window.checkBluehbeginnKeineBluete = function() {
  const editKeineBluete = $('#edit-no-flowering');
  const bluehbeginn = editKeineBluete.closest('.modal-body').find('input[type="date"]');

  editKeineBluete.on('change', function() {
    if ($(this).is(':checked')) {
      bluehbeginn.val('').attr('disabled', 'disabled');
    } else {
      bluehbeginn.removeAttr('disabled');
    }
  });

  if (editKeineBluete.is(':checked')) {
    bluehbeginn.val('').attr('disabled', 'disabled');
  }
};

/**
 * deleteDate
 * @param inputDeleteValue
 * @param inputDeleteClass
 * @param inputMultipleDeleteValue
 * @param elementDeleteWarning
 */
window.deleteDate = function(inputDeleteValue, inputDeleteClass, inputMultipleDeleteValue, elementDeleteWarning) {
  if (inputDeleteValue !== '') {
    $(inputDeleteValue).val('');
  }
  if (inputDeleteClass !== '') {
    $(inputDeleteClass).removeClass('text-orange');
  }
  if (inputMultipleDeleteValue !== '') {
    $(inputMultipleDeleteValue).val('');
  }
  if (elementDeleteWarning !== '') {
    $(elementDeleteWarning).remove();
  }
};

/**
 * copyLiefertermin
 * @param sectionID
 */
window.copyLiefertermin = function(sectionID) {
  const extraLiefertermin = $('#extraLiefertermin-' + sectionID).val();
  const inputLiefertermin = $('#inputLiefertermin-' + sectionID);
  const liefertermin = $('#liefertermin-' + sectionID);
  const lieferterminMobile = $('#lieferterminMobile-' + sectionID);
  $(liefertermin).html('<span class="bold">' + extraLiefertermin + '</span>');
  $(lieferterminMobile).html('<span class="bold">' + extraLiefertermin + '</span>');
  $(inputLiefertermin).val(extraLiefertermin);
};

/**
 * toggleErnteendeElement
 * @returns {boolean}
 */
window.toggleErnteendeElement = function() {
  $('#ernteende-element').toggleClass('fix-ernteende');
  $('#ernteende-space').toggleClass('show');
  return false;
};